import { useEffect, useState } from 'react';
import { deviceType } from 'react-device-detect';

export const useDeviceDetect = () => {
  //we can not use userAgent device detect in ssr ,because page have cache
  const [_deviceType, setDeviceType] = useState<string>('');
  // add  Mounted useEffect to fix hydration error
  useEffect(() => {
    setDeviceType(deviceType);
  }, []);
  return {
    isMobile: _deviceType === 'mobile',
    deviceType: _deviceType,
  };
};
